import { render, staticRenderFns } from "./hit-label.vue?vue&type=template&id=4fadfa0e&scoped=true"
import script from "./hit-label.vue?vue&type=script&lang=js"
export * from "./hit-label.vue?vue&type=script&lang=js"
import style0 from "./hit-label.vue?vue&type=style&index=0&id=4fadfa0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fadfa0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fadfa0e')) {
      api.createRecord('4fadfa0e', component.options)
    } else {
      api.reload('4fadfa0e', component.options)
    }
    module.hot.accept("./hit-label.vue?vue&type=template&id=4fadfa0e&scoped=true", function () {
      api.rerender('4fadfa0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/user/manage/components/hit-label.vue"
export default component.exports